module.exports = __webpack_public_path__ + "img/6.67ce1ff8.jpg";